<template>
  <div class="container-login-page">
    <div class="overlay"></div>
    <div class="wrapper-login-page">
      <!--header-->
      <div class="header">
        <img src="@/assets/icons/logo.svg" alt="">
        <div class="title">
          어드민 로그인
        </div>
      </div>
      <!--input area-->
      <div class="input-area">
        <styled-input-layout title="아이디 입력"
                             key-index="login-id-field"
                             v-model="editable.email"
                             :callback="() => { login(editable) }"/>

        <styled-input-layout title="비밀번호 입력"
                             key-index="login-pw-field"
                             v-model="editable.password"
                             type="password"
                             :callback="() => { login(editable) }"/>
      </div>
      <!--action area-->
      <div class="action-area">
        <div class="wrapper-button">
          <button class="btn-login"
                  :disabled="disabledButton"
                  @click="() => { login(editable) }">
            로그인
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import StyledInputLayout from '@/spa/components/LayoutStyledInput';

export default {
  name: 'LoginPanel',
  props: {
    login: {
      type: Function,
      isRequired: true,
    },
  },
  components: {
    StyledInputLayout,
  },
  watch: {
    'editable.email': {
      deep: true,
      handler(newData) {
        this.disabledButton = _.isEmpty(newData);
      },
    },
  },
  data() {
    return {
      editable: {
        email: '',
        password: '',
      },
      disabledButton: true,
    };
  },
};
</script>

<style lang="scss" scoped>

.container-login-page {
  position: relative;

  width: 100%;
  height: 100vh;
  transition: all 0.5s;

  background-position: left;
  background-size: cover;
  background-repeat: no-repeat;

  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;

  .overlay {
    position: absolute;
    left: 0;
    top: 0;

    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.2);
  }

  .wrapper-login-page {
    padding: 64px 32px;
    width: 360px;
    background-color: #ffffff;
    border-radius: 16px;
    text-align: left;
    z-index: 1;
    box-shadow: 1px 16px 32px rgba(0,0,0,0.3);

    .header {
      text-align: center;
      margin-bottom: 48px;
      img {
        height: 32px;
      }
      .title {
        margin-top: 8px;
      }
    }
    .action-area {

      .wrapper-button {
        display: flex;
        flex-direction: row-reverse;

        .btn-login {
          width: 84px;
          height: 36px;
          border-radius: 3px;
          background-color: #008ff8;
          border: none;
          color: #ffffff;

          &:disabled {
            background-color: #bbbbbb;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .container-login-page {
    width: 100%;

    .wrapper-login-page {
      width: 90%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/login/layouts/LoginPanel.vue